import { render, staticRenderFns } from "./imgUploadBox.vue?vue&type=template&id=859e0d42"
import script from "./imgUploadBox.vue?vue&type=script&lang=js"
export * from "./imgUploadBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports